import {NavList} from '@primer/react'
import type {ReactNode, Ref} from 'react'

import type {StackSectionStackEntry} from '../../../helpers/merge-box-status-calculator/stack-section-status'

export function StackEntryNavItem({
  entry,
  tabSuffix,
  className,
  isTitleMuted,
  leadingVisual,
  trailingVisual,
  entryRef,
  isCurrent,
  onClick,
}: {
  entry: StackSectionStackEntry
  tabSuffix: string
  className: string
  isTitleMuted: boolean
  leadingVisual: ReactNode
  trailingVisual: ReactNode
  entryRef?: Ref<HTMLAnchorElement>
  isCurrent?: boolean
  onClick?: () => void
}) {
  return (
    <NavList.Item
      ref={entryRef}
      href={`${entry.pull.url}${tabSuffix}`}
      aria-current={isCurrent}
      onClick={onClick}
      className={className}
    >
      <NavList.LeadingVisual>{leadingVisual}</NavList.LeadingVisual>
      <span className={isTitleMuted ? 'fgColor-muted' : ''}>{entry.pull.title}</span>
      <NavList.Description variant="block">
        <span className="fgColor-muted">
          #{entry.pull.number} · {entry.pull.headBranch}
        </span>
      </NavList.Description>
      <NavList.TrailingVisual>{trailingVisual}</NavList.TrailingVisual>
    </NavList.Item>
  )
}
